import React, { useCallback, useMemo, useRef, useState } from "react";
import { BackButton, InputWithLabel } from "../../../components/micro";
import { headChat } from "../../../assets/image";
import { useEffect } from "react";
import { Dash, Plus, Trash } from "../../../assets/svg/AllSvg";
import { useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";

const MAX_DIRECTORS = 9;

// validation on form
const validationSchema = Yup.object().shape({
  directorInformation: Yup.array()
    .of(
      Yup.object().shape({
        full_name: Yup.string().trim().required("Full Name is required"),
        email: Yup.string()
          .email("Invalid email")
          .required("Email is required"),
      })
    )
    .min(1, "At least one director information is required"),
});

const LocalDirector = () => {
  const [noOfDirector, setNoOfDirector] = useState(0);
  const [directorInformation, setDirectorInformation] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Add director
  useEffect(() => {
    if (noOfDirector > 0) {
      const newDirectors = Array.from({ length: noOfDirector }, () => ({
        full_name: "",
        email: "",
      }));
      setDirectorInformation(newDirectors);
    } else {
      setDirectorInformation([]);
    }
  }, [noOfDirector]);

  // Remove director
  const removeDirectorInformation = useCallback(
    (index) => {
      setDirectorInformation((prev) => [
        ...prev.slice(0, index),
        ...prev.slice(index + 1),
      ]);
      setNoOfDirector((prevCount) => Math.max(0, prevCount - 1));
    },
    [setDirectorInformation]
  );

  // Update director
  const updateDirectorInformation = useCallback(
    (index, field, value) => {
      setDirectorInformation((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        )
      );
    },
    [setDirectorInformation]
  );

  // Increment director count
  const handleEpIncrement = useCallback(() => {
    setNoOfDirector((prevCount) => Math.min(prevCount + 1, MAX_DIRECTORS));
  }, []);

  // Decrement director count
  const handleEpDecrement = useCallback(() => {
    setNoOfDirector((prevCount) => Math.max(prevCount - 1, 1));
  }, []);

  const isValid = useMemo(() => {
    return directorInformation.every(
      (director) => director.full_name.trim() && director.email.trim()
    );
  }, [directorInformation]);

  // Proceed with request
  const handleProceed = () => {
    if (isValid) {
      const payload = {
        details: directorInformation,
        amount:
          service?.service_requests_count < service?.detail?.no_of_free_request
            ? 0
            : service?.detail?.price,
        user_id: user_id,
        company_id: company_id,
        service_id: service?.id,
      };
      dispatch(createServicesRequest(payload)).then((res) => {
        if (res.type !== "createServicesRequest/fulfilled") return;
        const { service_requests_count, detail } = service || {};
        const price = detail?.price || 0;
        if (
          service_requests_count < service?.detail?.no_of_free_request ||
          price <= 0
        ) {
          navigate("/approver");
        } else if (buttonRef.current) {
          buttonRef.current.click();
        } else {
          navigate("/approver");
        }
      });
    }
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => {
          navigate("/service");
        }}
      />
      {/* Payment Button */}
      <a
        className="hidden"
        ref={buttonRef}
        href={createServicesRequestData?.data?.url}
      >
        Pay Now
      </a>
      <div className="sm:flex items-center sm:space-x-5 border-b-2 border-secondary_grey sm:pb-7 pb-2">
        <img src={headChat} alt="img" />
        <div className="sm:space-y-2 font-ebGaramond">
          <p className="sm:text-xl text-base">
            We see that you will need a request on:
          </p>
          <p className="sm:text-3xl text-xl">
            Appointment of New Local Director
          </p>
        </div>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ directorInformation }}
        validationSchema={validationSchema}
        onSubmit={handleProceed}
      >
        {({ errors, handleBlur, handleChange }) => (
          <Form className="space-y-5">
            <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
              <p className="sm:text-2xl text-xl font-ebGaramond">
                Let us guide you through the process:
              </p>
              {noOfDirector > 0 && (
                <p className="text-sm">i. What we need from you:</p>
              )}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3 sm:text-base text-sm">
                <span>1.</span>
                <p>How many new local directors are you appointing?</p>
              </div>
              <p className="sm:text-sm text-xs">
                Let us know how many new local directors you are looking to
                appoint:
              </p>
              <div>
                <p className="text-xs mb-2">No. of new local directors</p>
                {noOfDirector > 0 && (
                  <div className="flex items-center max-w-[8rem]">
                    <button
                      type="button"
                      onClick={handleEpDecrement}
                      className="bg-lightPrimary2 hover:bg-bgPrimary rounded-l-lg px-3 h-11"
                    >
                      <Dash />
                    </button>
                    <input
                      type="text"
                      id="quantity-input"
                      className="bg-lightPrimary2 h-11 text-center text-theme text-sm block w-full"
                      value={noOfDirector}
                      readOnly
                    />
                    <button
                      type="button"
                      onClick={handleEpIncrement}
                      className="bg-lightPrimary2 hover:bg-bgPrimary rounded-r-lg px-3 h-11"
                    >
                      <Plus className="fill-theme" />
                    </button>
                  </div>
                )}
                {noOfDirector <= 0 && (
                  <ReactSelect
                    className={"p-0"}
                    id="director"
                    placeholder="No. of new local directors"
                    options={[
                      { value: 1, label: "1" },
                      { value: 2, label: "2" },
                    ]}
                    isClearable
                    isLoading={false}
                    onChange={(e) => setNoOfDirector(e?.value || 0)}
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: `1px solid #cdddeb`,
                        borderRadius: "0.3rem",
                        paddingTop: "2px",
                        paddingBottom: "2px",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #cdddeb",
                        },
                      }),
                    }}
                  />
                )}
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg sm:text-base text-sm px-4 py-3">
                <span>2.</span>
                <p>Fill in the basic information of the new local director</p>
              </div>
              {directorInformation?.length > 0 && (
                <div className="border-remove-bottom">
                  {directorInformation?.map((element, index) => (
                    <div
                      key={index}
                      className={`space-y-3 ${
                        !(directorInformation.length - 1 === index) &&
                        "pb-5 border-b-2 border-secondary_grey"
                      }`}
                    >
                      <div className="flex justify-between items-center">
                        <p className="text-sm">
                          Director {index + 1} Information:
                        </p>
                        {directorInformation.length > 1 && (
                          <button
                            className="p-4"
                            onClick={() => removeDirectorInformation(index)}
                          >
                            <Trash />
                          </button>
                        )}
                      </div>
                      <InputWithLabel
                        className={
                          errors.directorInformation?.[index]?.full_name
                            ? "input-error"
                            : "border"
                        }
                        idFromName={`directorInformation[${index}].full_name`}
                        type={"text"}
                        label={"Full Name"}
                        value={element.full_name}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          updateDirectorInformation(
                            index,
                            "full_name",
                            e.target.value
                          );
                          handleChange(e);
                        }}
                        errors={errors.directorInformation?.[index]?.full_name}
                        errorsText={
                          errors.directorInformation?.[index]?.full_name
                        }
                      />
                      <InputWithLabel
                        className={
                          errors.directorInformation?.[index]?.email
                            ? "input-error"
                            : "border"
                        }
                        idFromName={`directorInformation[${index}].email`}
                        type={"email"}
                        label={"Email"}
                        value={element.email}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          updateDirectorInformation(
                            index,
                            "email",
                            e.target.value
                          );
                          handleChange(e);
                        }}
                        errors={errors.directorInformation?.[index]?.email}
                        errorsText={errors.directorInformation?.[index]?.email}
                      />
                    </div>
                  ))}
                </div>
              )}
              {noOfDirector > 0 && (
                <>
                  <p className="text-sm">ii. What to expect Next! </p>
                  <div className="bg-light_extra_green text-theme space-y-2 sm:text-sm text-xs rounded-lg px-4 py-3">
                    <p>
                      1. We will send a link to the email provided. We will need
                      the specific director to login and provide the relevant
                      information for our KYC check.
                    </p>
                    <p>
                      2. We will do a KYC check and prepare relevant documents
                      for signature.
                    </p>
                    <p>
                      3. Get the relevant document signed and we will handle the
                      rest.
                    </p>
                  </div>
                </>
              )}
              {noOfDirector <= 0 && (
                <>
                  <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 sm:text-base text-sm py-3">
                    <span>3.</span>
                    <p>
                      We will send a link to the email provided. We will need
                      the specific director to login and provide the relevant
                      information for our KYC check.
                    </p>
                  </div>
                  <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 sm:text-base text-sm py-3">
                    <span>4.</span>
                    <p>
                      We will do a KYC check and prepare relevant documents for
                      signature.
                    </p>
                  </div>
                  <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg sm:text-base text-sm px-4 py-3">
                    <span>5.</span>
                    <p>
                      Get the relevant document signed and we will handle the
                      rest.
                    </p>
                  </div>
                </>
              )}
              <p className="text-sm">
                Once the request is opened, you can easily manage it over at the
                “On-Going” service page.
              </p>
            </div>
            <div className="flex items-center justify-between space-x-1 bg-light_primary_shades rounded-lg px-4 py-3">
              <p className="font-semibold">Total Payable :</p>
              <div>
                <p className="text-xs">
                  {service?.service_requests_count}/
                  {service?.detail?.no_of_free_request ?? 0} used
                </p>
                {service?.service_requests_count >=
                service?.detail?.no_of_free_request
                  ? `$${service?.detail?.price}`
                  : "Free"}
              </div>
            </div>
            <div className="box !rounded-xl flex items-center justify-between">
              <button
                type="submit"
                className={`${
                  !isValid || noOfDirector === 0 || createServicesRequestLoading
                    ? "btn-outline-disabled"
                    : "btn-theme"
                } uppercase`}
                disabled={
                  !isValid || noOfDirector === 0 || createServicesRequestLoading
                }
              >
                {createServicesRequestLoading
                  ? "Loading..."
                  : "Proceed with request"}
              </button>
              <div>
                <p className="text-xs">Total:</p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default LocalDirector;
